var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.hasGroupAccess ||
    _setup.isUnpublished ||
    _setup.isPending ||
    _setup.isExpiring ||
    _setup.isExpired ||
    _setup.isArchived
    ? _c(
        "div",
        { staticClass: "d-inline-flex gap-1" },
        [
          _setup.hasGroupAccess
            ? _c("i", {
                staticClass: "bi bi-person-fill",
                attrs: { title: "This page is assigned group access" },
              })
            : _vm._e(),
          _vm._v(" "),
          _setup.isArchived
            ? _c("i", {
                staticClass: "bi bi-archive-fill",
                class: { "text-danger": !_vm.isActive },
                attrs: { title: "Archived" },
              })
            : _vm._e(),
          _vm._v(" "),
          _setup.isUnpublished
            ? _c("i", {
                staticClass: "bi bi-x-circle-fill",
                class: { "text-danger": !_vm.isActive },
                attrs: { title: "Unpublished" },
              })
            : [
                _setup.isPending
                  ? _c("i", {
                      staticClass: "bi bi-clock-fill",
                      class: { "text-info": !_vm.isActive },
                      attrs: { title: "Pending" },
                    })
                  : _setup.isExpiring
                  ? _c("i", {
                      staticClass: "bi bi-clock-fill",
                      class: { "text-warning": !_vm.isActive },
                      attrs: { title: "Expiring" },
                    })
                  : _setup.isExpired
                  ? _c("i", {
                      staticClass: "bi bi-clock-fill",
                      class: { "text-danger": !_vm.isActive },
                      attrs: { title: "Expired" },
                    })
                  : _vm._e(),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }